import { LoadingOutlined, WarningTwoTone, CheckCircleTwoTone } from '@ant-design/icons';

import { Space, Typography } from 'antd';

import { UI_JOB_STATUS } from './BulkUploaderUtils';

// danger
// success
// warning
const ParserInfoMessage = ({ status, message }) => {
  // TODO: add other status
  const map = {
    [UI_JOB_STATUS.errorOnExecution]: {
      type: 'danger',
      icon: <WarningTwoTone twoToneColor="red" />,
      text: message ?? 'Error while executing the job, Please upload again!'
    },
    [UI_JOB_STATUS.validating]: {
      type: 'secondary',
      icon: <LoadingOutlined />,
      text: 'You will be notified on email once parsing is completed.'
    },
    [UI_JOB_STATUS.submitting]: {
      type: 'secondary',
      icon: <LoadingOutlined />,
      text: 'You will be notified on email once files are created'
    },
    [UI_JOB_STATUS.submitted]: {
      type: 'secondary',
      icon: <CheckCircleTwoTone className="checked_two_tone_background" twoToneColor="green" />,
      text: 'Documents created successfully'
    }
  };

  if (!map[status]) {
    return null;
  }
  return (
    <Space>
      {map[status]?.icon} <Typography.Text type={map[status].type}>{map[status].text}</Typography.Text>
    </Space>
  );
};

export default ParserInfoMessage;
